import { Pipe, PipeTransform } from '@angular/core';

interface StatusInfo {
  [k: string]: { [v: string]: string };
}

@Pipe({
  name: 'statusText',
})
export class StatusTextPipe implements PipeTransform {
  private statusTexts: StatusInfo = {
    3: {
      caption: $localize`akceptacja`,
      btClassName: 'bg-success',
    },
    2: {
      caption: $localize`przekazano do akceptacji`,
      btClassName: 'bg-info',
    },
    1: {
      caption: $localize`brak akceptacji`,
      btClassName: 'bg-warning',
    },
    0: {
      caption: $localize`oczekuje na akceptację`,
      btClassName: 'bg-info',
    },
  };

  transform(value: number, part = 'text'): string {
    if (part === 'text') {
      return this.statusTexts[value]?.caption || '';
    }

    if (part === 'theme') {
      return this.statusTexts[value]?.btClassName || '';
    }
  }
}
